// extracted by mini-css-extract-plugin
export default {"imageWrapper":"Cu-z","videoWrapper":"Du-z","twoColumnImage":"Eu-z"};